import React, { memo, useEffect } from 'react'
import styles from './index.less'
import CustomNodeWrapper from '../../configuration/wrapper'
import type { LLMActionNodeData } from '../types'
import type { ComponentType } from 'react'
import type { NodeProps } from 'reactflow'

function LLMNodeRender({ data, selected }: NodeProps<LLMActionNodeData>) {
  useEffect(() => {
    console.log('dataChanged')
  }, [data])
  return (
    <CustomNodeWrapper nodeData={data} selected={selected}>
      <span className={`${styles.nodeText}`}>{data.nodeName}</span>
    </CustomNodeWrapper>
  )
}

const LLMNode: ComponentType<NodeProps<LLMActionNodeData>> = memo(LLMNodeRender)

export default LLMNode
